<template>
    <div class="notice-box">
        <div class="notice-tip flex justify-between"><span>平台消息</span><div class="more text-xs pointer" @click="toPage('/main/notices')">更多<RightOutlined /></div></div>
        <div class="scroll-inner-box">
            <vue3-seamless-scroll :list="noticeList" class="scroll-notice" :hover="true" :step="1" :wheel="true" :singleHeight="36">
                <div class="scroll-cell flex items-center" v-for="(item, index) in noticeList" :key="index">
                    <div class="scroll-left">
                        <img v-if="item.type==='[订单变更]'" src="@/assets/home/order-change.png" class="notice-img"/>
                        <img v-if="item.type==='[公告]'" src="@/assets/home/notice-icon.png" class="notice-img"/>
                        <img v-if="item.type==='[商品价格变更]'" src="@/assets/home/price-change-icon.png" class="notice-img"/>
                        <img v-if="item.type==='[结算方式变更]'" src="@/assets/home/price-change-icon.png" class="notice-img"/>
                        <!-- <div class="unread-edge"></div> -->
                    </div>
                    <div class="scroll-middle ml-8">
                        <div class="scroll-middle-top flex items-center">
                            <div class="notice-type mr-10">{{item.type.replace('[','').replace(']','')}}</div>
                            <div class="notice-date truncate ">{{item.message}}</div>
                        </div>
                        <!-- <div class="notice-cnt mt-8">{{item.message}}</div> -->
                    </div>
                </div>
            </vue3-seamless-scroll>
        </div>
    </div>
</template>
<script setup>
    import { Vue3SeamlessScroll } from "vue3-seamless-scroll"
    import { RightOutlined } from "@ant-design/icons-vue";
    import { ref } from "vue"
    import { useRouter } from "vue-router";
    const props = defineProps({
        noticeList: {
            required: true, // 是否必传
            type: Array,
            default: () => []
        },
    })
    // const noticeList = ref([1,2,3,4])
    const router = useRouter();
    function toPage(url,name){
        router.push(url)
    }
</script>

<style lang="scss" scoped>
.notice-box{
    width: 334px;
    height: 102px;
    padding:14px;
    background: linear-gradient(180deg, #E1DFF5 0%, #EBE9FD 100%);
    border-radius: 10px;
    .notice-tip{
        font-size: 16px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        color: #363356;
        text-align:left;
        margin-bottom:14px;
        .more{
            font-weight: 400;
            color: #8886A1;
        }
    }
    .scroll-inner-box {
        width: 100%;
        height: 50px;
        overflow: hidden;

        .scroll-cell {
            width: 100%;
            height: 30px;
            margin-bottom: 5px;
            border-radius: 14px;

            .scroll-left {
                width: 22px;
                height:22px;
                position:relative;
                .notice-img{
                    width:22px;
                    height:22px;
                    border-radius:22px;
                }
                .unread-edge{
                    position:absolute;
                    width: 6px;
                    height: 6px;
                    border-radius: 6px;
                    right:2px;
                    top:0;
                    background: #FF2222;
                }
                
            }

            .scroll-middle {
                width: 276px;
                .scroll-middle-top{
                        // padding-top:4px;
                    .notice-type{
                        font-size: 14px;
                        font-family: MicrosoftYaHei, MicrosoftYaHei;
                        font-weight: bold;
                        color: #333333;
                    }
                    .notice-date{
                        max-width: 200px;
                        font-size: 12px;
                        font-family: MicrosoftYaHei;
                        color: #999999;
                    }
                }
                .notice-cnt{
                    font-size: 12px;
                    font-family: MicrosoftYaHei;
                    color: #666666;
                    // margin-bottom:14px;
                    text-align:left;
                    display: -webkit-box;
                    overflow: hidden;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }
            }

            .price-value {
                font-size: 14px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                color: #333333;
                vertical-align: text-bottom;
            }

            .price-unit {
                font-size: 12px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                color: #666666;
                vertical-align: text-bottom;
            }
        }
    }
}

</style>